var render = function render(){var _vm=this,_c=_vm._self._c;return _c('searches-groups-list-page',{attrs:{"resource-name":"group_library","is-initiated":_vm.groupsAreInitiated,"hide-filters":true,"data":_vm.groupsData,"no-data":_vm.groupsNoData,"all-loaded":_vm.groupsAllLoaded,"can-load-more-string":"groupsCanLoadMore","is-busy":_vm.groupsAreBusy}})
}
var staticRenderFns = []

export { render, staticRenderFns }